import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ticketData: null,
  error: null,
};

const ticketDataSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    fetchTicketDataSuccess: (state, action) => {
      state.ticketData = action.payload;
      state.error = null;
    },
    fetchTicketDataError: (state, action) => {
      state.ticketData = null;
      state.error = action.payload;
    },
  },
});

export const { fetchTicketDataSuccess, fetchTicketDataError } = ticketDataSlice.actions;
export default ticketDataSlice.reducer;